import { FormEvent, useEffect, useState } from 'react';
import OneliveShell from './OneliveShell';
import { loginAccount, navigate, showOneliveToast } from './api';
import { normalizeLoginPageUrl, sanitizeLoginRedirect } from './authRedirect';

export default function OneliveLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [redirect, setRedirect] = useState('/');

  useEffect(() => {
    normalizeLoginPageUrl();
    const params = new URLSearchParams(window.location.search);
    setRedirect(sanitizeLoginRedirect(params.get('redirect'), '/'));
  }, []);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await loginAccount(email.trim(), password);
      showOneliveToast('로그인 되었습니다.', 'success');
      navigate(sanitizeLoginRedirect(redirect, '/'));
    } catch (err: unknown) {
      const message = (err as { message?: string })?.message || '아이디 또는 비밀번호가 올바르지 않습니다.';
      showOneliveToast(message, 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <OneliveShell>
      <div className="onelive-page onelive-auth-ref-page is-compact">
        <main className="onelive-main">
          <div className="onelive-ref-sub-title"><span>로그인</span></div>

          <div className="onelive-auth-ref-card">
            <h2>로그인</h2>
            <form className="onelive-auth-ref-form" onSubmit={onSubmit}>
              <input
                type="text"
                placeholder="아이디"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
              <input
                type="password"
                placeholder="비밀번호"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
              <button type="button" className="onelive-auth-ref-link-btn" onClick={() => navigate('/forgot-password')}>
                비밀번호 찾기
              </button>
              <button type="submit" className="onelive-auth-ref-submit" disabled={submitting}>
                {submitting ? '처리 중...' : '로그인'}
              </button>
            </form>

            <p className="onelive-auth-ref-footer">
              아직 회원이 아니신가요?{' '}
              <button type="button" onClick={() => navigate('/register')}>회원가입</button>
            </p>
          </div>
        </main>
      </div>
    </OneliveShell>
  );
}
